import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentsRoutingModule } from './students-routing.module';
import { StudentsComponent } from './students/students.component';
import { AllStudentsComponent } from './all-students/all-students.component';
import { MatTableModule, MatSelectModule, MatInputModule, MatSortModule, MatIconModule,
  MatButtonModule, MatSnackBarModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoStudentSelectedComponent } from './no-student-selected/no-student-selected.component';
import { StudentComponent } from './student/student.component';
import { CoreTasksComponent } from './core-tasks/core-tasks.component';
import { ClassService } from '../class.service';
import { CoreTaskService } from './core-task.service';
import { SemsoSnackbarService } from '../semso-snackbar.service';
import { StartedStudentsComponent } from './started-students/started-students.component';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { StudentsService } from 'app/students.service';
import { ShortlistService } from './shortlist.service';

@NgModule({
  imports: [
    CommonModule,
    StudentsRoutingModule,
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    BreadcrumbModule
  ],
  declarations: [StudentsComponent, AllStudentsComponent,
    NoStudentSelectedComponent, StudentComponent, CoreTasksComponent, StartedStudentsComponent],
  providers: [
    ClassService,
    StudentsService,
    CoreTaskService,
    SemsoSnackbarService,
    ShortlistService
  ]
})
export class StudentsModule { }



// WEBPACK FOOTER //
// ./src/app/students/students.module.ts